/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import EquipmentAllotment from './equipment-allotment';
import EquipmentAllotmentDetail from './equipment-allotment-detail';
import EquipmentAllotmentUpdate from './equipment-allotment-update';
import EquipmentAllotmentDeleteDialog from './equipment-allotment-delete-dialog';

const EquipmentAllotmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<EquipmentAllotment />} />
    <Route path="new" element={<EquipmentAllotmentUpdate />} />
    <Route path=":id">
      <Route index element={<EquipmentAllotmentDetail />} />
      <Route path="edit" element={<EquipmentAllotmentUpdate />} />
      <Route path="delete" element={<EquipmentAllotmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EquipmentAllotmentRoutes;
